module.exports = flarum.core.compat['admin/components/ExtensionPage'];